import get from 'lodash/get'

import gtmHelpers from '../gtmHelpers'
import {formatPrice} from '../utils'
import {segment} from './helpers'
import {TRANSACTION_TYPE_BUY, TRANSACTION_TYPE_RENT} from '../const'

export const pdpAddedCompleteLook = () => segment('Added Complete Look')

export const pdpAccordionClicked = (payload) => {
  segment('Clicked PDP Accordion', payload)
}

export const pdpClicked = (targetLinkName, targetLinkUrl, eventName) =>
  segment(eventName || 'Clicked PDP Link', {
    targetLinkName,
    targetLinkUrl,
    currentPath: window.location.pathname,
  })

export const pdpTransactionTypeClicked = ({productCategorySlug, productName, transactionType}) => {
  segment('Clicked PDP Transaction Option', {
    productCategory: productCategorySlug,
    name: productName,
    transactionType: {
      [TRANSACTION_TYPE_BUY]: 'Buy New',
      [TRANSACTION_TYPE_RENT]: 'Rent',
    }[transactionType],
  })
}

/**
 * A segment event fired upon clicking on a thumbnail or carousel in PDP
 *
 * @param {Number} photoIndex The current photo index that is selected.
 * @param {String} productName The displayed produc't name.
 * @param {String} productId The displayed product's id.
 * @param {String} type The component the user interacted with. (eg: "thumbnails" or "carousel")
 * @return {void}
 */

export const advancedPdpImageClicked = (photoIndex, productName, productId, type) =>
  segment('Advanced PDP Image', {
    photoIndex,
    productName,
    productId,
    type,
  })

/**
 * Fires events upon a view of a single product page
 *
 * @param {Object} product A full product object
 * @param {String} origin Internal origin of this view, if it exists
 */
export const viewedProduct = (product, origin) => {
  if (typeof product !== 'object') {
    return
  }

  const uuid = get(product, 'id')
  const name = get(product, 'name')
  const price = formatPrice(get(product, 'price'))
  const categorySlug =
    get(product, 'defaultDisplayCategorySlug') ||
    get(product, 'setSpecs.defaultDisplayCategorySlug')

  segment('Viewed Product', {
    uuid,
    name,
    quantity: 1,
    slug: get(product, 'slug'),
    productCategory: get(product, 'setSpecs.defaultDisplayCategoryName'),
    price,
    origin,
  })

  gtmHelpers.addDetailImpression(gtmHelpers.product(uuid, name, categorySlug, price, 1))
}
export const clickedBuyPathExperimentRentalControlButton = () =>
  segment('Clicked Buy Path Experiment PDP link to rental')
